import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { RequiredSkillListComponent } from './required-skill-list/required-skill-list.component'

export const requiredSkillRoutes: Route[] = [
  {
    path: 'required-skills',
    component: RequiredSkillListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'required-skills/:id/edit',
    redirectTo: 'required-skills/:id',
    pathMatch: 'full'
  },
  {
    path: 'required-skills/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'RequiredSkill',
        nameSingular: 'Required Skill',
        namePlural: 'Required Skills',
        path: 'required-skills',
        slug: 'taxonomies/required-skills',
        title: 'Required Skills'
      }),
      permission: 'readTaxonomies'
    }
  }
]
